// Copy of the "Suppliers" walkthrough. The rules every text follows are in ../../de/help.js.
// Tab, field and button names are written as the pages show them (../supplier.js, ../supplierInsights.js,
// ../supplierHistory.js, ../supplierImport.js).
export default {
  title: "Suppliers",
  // Short names of the views, for the header, the timeline and "Continue to …".
  section: {
    SupplierOverview: "Overview",
    SupplierSetup: "Setup",
    SupplierComparison: "Comparison",
    SupplierDetail: "Supplier",
    MaterialDetail: "Material",
    ProjectDetail: "Project",
  },
  related: "Connections",
  step: {
    list: {
      text: "These are the suppliers your company buys material from or rents machines from. A click on a row opens the supplier.",
    },
    row: {
      text: "Kind, town and further locations sit under the name, which tells two branches of one company apart. On the right is whom you call there.",
    },
    create: {
      text: "Create new supplier opens the empty form. It needs nothing but a name.",
    },
    invitation: {
      text: "Your purchase prices do not belong to any supplier yet. Set up suppliers turns their names into suppliers in one step.",
    },
    views: {
      text: "This switches to the comparison. It shows where another supplier is cheaper than your default.",
    },
    "setup-table": {
      text: "Every name your purchase prices have gone by is listed here. Beside it, how many materials and machines carry it.",
    },
    "setup-target": {
      text: "On the right you choose what it becomes, a new supplier, an existing one or your own company. If two names belong to one company, choose the same supplier for both.",
    },
    "setup-preview": {
      text: "Preview names the suppliers that will be created. If a name there is no supplier, choose another one above.",
    },
    "setup-apply": {
      text: "Set up asks once more. After that every purchase price belongs to a supplier, and you change prices in its assortment.",
    },
    comparison: {
      text: "The comparison shows where you could buy cheaper.",
    },
    "comparison-cards": {
      text: "Two suppliers side by side, a card each. Both show the materials both carry, row by row. The cheaper price is bold and green, the star marks your default.",
    },
    "comparison-pick": {
      text: "At the top of each card you choose the supplier. Below, for how many shared materials it is the cheaper one.",
    },
    "comparison-only": {
      text: "What only this supplier carries is folded under its card.",
    },
    "comparison-add": {
      text: "The plus beside the cards puts one more supplier beside them, up to six. From three cards on each has a cross to remove it.",
    },
    "comparison-history": {
      text: "A click on a row shows the material's price history at the compared suppliers.",
    },
    head: {
      text: "The head carries the supplier's name. Under Actions you archive it once you no longer buy there.",
    },
    tabs: {
      text: "The tabs divide the page up. Which tab is open is part of the page's address.",
    },
    base: {
      text: "Name and kind are the master data. Kinds such as building materials dealer or equipment rental are created right in the field.",
    },
    reach: {
      text: "Phone, e-mail and website, and the customer number your company has with this supplier.",
    },
    address: {
      text: "The supplier's head office. Pick the address from the search; further addresses are locations.",
    },
    discount: {
      text: "The discount is booked with every price of this supplier. A change applies from today, earlier bookings keep theirs.",
    },
    terms: {
      text: "Early payment discount and freight are never booked. They count where a material's purchasing or the comparison works out delivered prices.",
    },
    // The button "Rental and transport", a rental supplier's terms. Krämer carries no machines.
    transport: {
      text: "Rental and Transport are for rented machines: rental days, days without usage and the transport tariff. They show at suppliers with machines in their assortment; anywhere else this button brings them up.",
    },
    contacts: {
      text: "These are your contacts at the supplier, with position and phone. They are stored with Save.",
    },
    locations: {
      text: "Locations are further addresses of the supplier, such as a depot, with phone, dispatch and their own contacts. They share its prices.",
    },
    assortment: {
      text: "The assortment shows what the supplier carries, at today's price. The pencil changes a price. At the top you switch between materials and machines; under a machine stand its accessories.",
    },
    "assortment-rows": {
      text: "The star marks the default a project takes the material over with. A click on the name opens the material's purchasing.",
    },
    following: {
      text: "After a backdated change, booked reports stay at the old price. Update puts them on the price of their day.",
    },
    "price-list": {
      text: "Change prices opens the whole assortment at today's prices. You enter the new ones, valid from today.",
    },
    "price-import": {
      text: "Import price list is in the ⋮ beside it: it reads the supplier's file and matches each line to a material or machine.",
    },
    revisions: {
      text: "The history shows every price of a row with the day it holds from. A wrong price is corrected or removed here.",
    },
    files: {
      text: "File storage is for price lists, framework contracts and certificates. A due date changes colour as it comes closer.",
    },
    activity: {
      text: "Activity shows every change with its day and who made it. Under References you see which materials and machines this supplier is on.",
    },
    save: {
      text: "Save writes the master data, conditions, contacts and locations at once. A tab with an error in it is brought to the front.",
    },
    again: {
      text: "This button is on every page that has an explanation. One click starts it again.",
    },
    // Connections: where a supplier's prices arrive.
    "material-purchase": {
      text: "A material is where its suppliers meet. Its Purchasing tab lists everyone who carries it, at today's price.",
    },
    "project-prices": {
      text: "In a project every report books the supplier's price of the report's day. A project price the supplier gave the project comes first.",
    },
  },
}
